// instrumentation-client.ts
// Next.js 15.3+ client instrumentation - runs before React hydration
// This captures errors earlier than component-based initialization
// See: https://nextjs.org/blog/next-15-3#client-instrumentation-hook

import Appsignal from "@appsignal/javascript";
import { plugin } from "@appsignal/plugin-window-events";

if (typeof window !== "undefined" && process.env.NEXT_PUBLIC_APPSIGNAL_FRONTEND_KEY) {
  const appsignal = new Appsignal({
    key: process.env.NEXT_PUBLIC_APPSIGNAL_FRONTEND_KEY,
    revision: process.env.NEXT_PUBLIC_APP_VERSION,
  });
  appsignal.use(plugin());

  // Expose for ErrorBoundary usage
  (window as unknown as { __appsignal: Appsignal }).__appsignal = appsignal;
}
